<template>
  <div class="content">
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">USDT合约</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0">交易对</h3>
            <p class="text-sm mb-0"></p>
          </template>

          <div>
            <b-col
              cols="12"
              class="
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
            >
              <div class="text-left">
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Search..."
                >
                </base-input>
              </div>
              <div
                style="margin-right: 10px"
                lg="6"
                cols="5"
                class="text-right"
              >
                <el-select
                  class="select-primary pagination-select"
                  v-model="shock_times"
                  placeholder="震幅周期"
                  style="margin-left: 10px; width: 150px"
                >
                  <el-option
                    class="select-primary"
                    key="shock_times_"
                    label="震幅周期"
                    value=""
                  >
                  </el-option>

                  <el-option
                    class="select-primary"
                    key="shock_times_100"
                    label="震幅周期：100"
                    value="100"
                  >
                  </el-option>

                  <el-option
                    class="select-primary"
                    key="shock_times_50"
                    label="震幅周期：50"
                    value="50"
                  >
                  </el-option>
                  <el-option
                    class="select-primary"
                    key="shock_times_30"
                    label="震幅周期：30"
                    value="30"
                  >
                  </el-option>
                </el-select>

                <el-select
                  class="select-primary pagination-select"
                  v-model="shock_length"
                  placeholder="震幅计算长度"
                  style="margin-left: 10px; width: 200px"
                >
                  <el-option
                    class="select-primary"
                    key="shock_length_"
                    label="震幅计算长度"
                    value=""
                  >
                  </el-option>

                  <el-option
                    class="select-primary"
                    key="shock_length_10"
                    label="震幅计算长度：10"
                    value="10"
                  >
                  </el-option>

                  <el-option
                    class="select-primary"
                    key="shock_length_20"
                    label="震幅计算长度：20"
                    value="20"
                  >
                  </el-option>
                  <el-option
                    class="select-primary"
                    key="shock_length_30"
                    label="震幅计算长度：30"
                    value="30"
                  >
                  </el-option>
                  <el-option
                    class="select-primary"
                    key="shock_length_50"
                    label="震幅计算长度：50"
                    value="50"
                  >
                  </el-option>
                  <el-option
                    class="select-primary"
                    key="shock_length_100"
                    label="震幅计算长度：100"
                    value="100"
                  >
                  </el-option>
                  <el-option
                    class="select-primary"
                    key="shock_length_200"
                    label="震幅计算长度：200"
                    value="200"
                  >
                  </el-option>
                </el-select>
                <base-button
                  style="margin-left: 30px"
                  type="success"
                  @click.native="handleEdit()"
                  >添加交易对</base-button
                >
              </div>
            </b-col>
            <el-table
              :data="queriedData"
              :default-sort="{ prop: 'trade_turnover', order: 'descending' }"
              row-key="contract_code"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.prop"
                v-bind="column"
              >
              </el-table-column>
              <el-table-column min-width="180px" align="right" label="Actions">
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button
                    @click.native="handleEdit($index, row)"
                    type="success"
                    >编辑</base-button
                  >

                  <base-button
                    v-if="row.is_fav == 0"
                    @click.native="handleLike($index, row, 1)"
                    type="success"
                    >加入自选</base-button
                  >
                  <base-button
                    v-if="row.is_fav == 1"
                    @click.native="handleLike($index, row, 0)"
                    type="warning"
                    >取消自选</base-button
                  >
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            "
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              :current="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>

          <!--Form modal-->
          <modal :show.sync="modals.form" size="lg">
            <h6 slot="header" class="modal-title">
              {{ form_title }}
            </h6>
            <template>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <b-row class="form-group">
                    <label
                      for="example-time-input"
                      class="col-md-2 col-form-label form-control-label"
                      >交易对</label
                    >
                    <b-col md="9">
                      <base-input
                        alternative
                        v-model="formModal.symbol"
                        class="mb-3"
                        :rules="{ required: true }"
                        type="text"
                        step="any"
                        name="交易对"
                        placeholder="请填写交易对名称，如BTC-USDT"
                      >
                      </base-input>
                    </b-col>
                  </b-row>

                  <b-row class="form-group">
                    <label
                      for="example-time-input"
                      class="col-md-2 col-form-label form-control-label"
                      >市场<br
                    /></label>
                    <b-col md="9">
                      <base-input>
                        <select
                          class="form-control"
                          v-model="formModal.platform"
                        >
                          <option value="1">火币</option>
                          <option value="2">币安</option>
                        </select>
                      </base-input>
                    </b-col>
                  </b-row>

                  <b-row class="form-group">
                    <label
                      for="example-time-input"
                      class="col-md-2 col-form-label form-control-label"
                      >顶部压力点</label
                    >
                    <b-col md="9">
                      <base-input
                        alternative
                        v-model="formModal.keyLevelRise"
                        class="mb-3"
                        :rules="{ required: true }"
                        type="number"
                        step="any"
                        name="顶部压力点"
                        placeholder="顶部压力点"
                        prepend-icon="ni ni-money-coins"
                      >
                      </base-input>
                    </b-col>
                  </b-row>

                  <b-row class="form-group">
                    <label
                      for="example-time-input"
                      class="col-md-2 col-form-label form-control-label"
                      >底部压力点</label
                    >
                    <b-col md="9">
                      <base-input
                        alternative
                        v-model="formModal.keyLevelFall"
                        class="mb-3"
                        :rules="{ required: true }"
                        type="number"
                        step="any"
                        name="底部压力点"
                        placeholder="底部压力点"
                        prepend-icon="ni ni-money-coins"
                      >
                      </base-input>
                    </b-col>
                  </b-row>

                  <div class="text-center" style="margin-top: 50px">
                    <base-button type="primary" native-type="submit"
                      >保存</base-button
                    >
                  </div>
                </b-form>
              </validation-observer>
            </template>

            <template slot="footer">
              <base-button
                type="link"
                class="ml-auto"
                @click="modals.form = false"
                >关闭</base-button
              >
            </template>
          </modal>
        </card>
      </div>
    </b-container>
  </div>
</template>
<script>
import linearSwapApi from "../../api/linearswap";
var moment = import("moment");
import PriceLabel from "./priceLabel";
import ShockLabel from "./shockLabel";
import Fuse from "fuse.js";

import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import { platform } from "chart.js";
// import swal from "sweetalert2";

export default {
  mixins: [clientPaginationMixin],
  components: {
    PriceLabel,
    ShockLabel,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    // contract_code: "MANA-USDT"
    // index_price: 0.7693254853333333
    // index_ts: 1621684761013
    return {
      shock_length: "",
      shock_times: "",
      modals: {
        form: false,
      },
      form_title: "",
      formModal: {
        id: 0,
        symbol: "",
        platform: "1",
        keyLevelRise: "",
        keyLevelFall: "",
      },

      fuseSearch: null,
      selectedKLine: "1min",

      propsToSearch: ["contract_code"],
      tableColumns: [
        {
          prop: "contract_code",
          label: "合约代码",
          minWidth: 130,
          sortable: true,
        },
        {
          prop: "platform",
          label: "平台",
          minWidth: 120,
          sortable: true,
          formatter: this.formatterPlatform,
        },

        {
          prop: "close",
          label: "当前价",
          minWidth: 150,
          sortable: true,
          formatter: this.formatterPrice,
        },

        {
          prop: "shock1min",
          label: "1min震幅",
          minWidth: 130,
          sortable: true,
          formatter: this.formatterShock,
        },
        {
          prop: "shock5min",
          label: "5min震幅",
          minWidth: 130,
          sortable: true,
          formatter: this.formatterShock,
        },
        {
          prop: "shock15min",
          label: "15min震幅",
          minWidth: 140,
          sortable: true,
          formatter: this.formatterShock,
        },
        {
          prop: "shock4hour",
          label: "4hour震幅",
          minWidth: 140,
          sortable: true,
          formatter: this.formatterShock,
        },

        {
          prop: "keyLevelRise",
          label: "顶部压力位",
          minWidth: 220,
          sortable: true,
          formatter: this.formatterPrice1,
        },

        {
          prop: "keyLevelFall",
          label: "底部支撑位",
          minWidth: 220,
          sortable: true,
          formatter: this.formatterPrice1,
        },
      ],

      tableData: [],
      selectedRows: [],
    };
  },
  methods: {
    //[Vue warn]: Duplicate keys detected: '1621695305'. This may cause an update error.
    formatterIncrease(value, cloumn) {
      let increase = parseFloat(value[cloumn.property]);
      let priceClassName;
      if (increase > 1) {
        increase = increase.toFixed(2) + "%";
        priceClassName = "text-success";
      } else {
        increase = increase.toFixed(2) + "%";
        priceClassName = "text-danger";
      }
      return this.$createElement("price-label", {
        props: { priceClassName, price: increase },
      });
    },
    formatterShock(value, cloumn) {
      // console.log("value:", value);
      const shockValue = value[cloumn.property];
      if (shockValue) {
        return this.$createElement("shock-label", {
          props: { shockValue: shockValue },
        });
      } else {
        return "-";
      }
    },
    formatterPlatform(value, cloumn) {
      let val = parseFloat(value[cloumn.property]);
      return +val == 1 ? "火币" : "币安";
    },
    formatterPrice1(value, cloumn) {
      let price = parseFloat(value[cloumn.property]);
      return price;
    },
    formatterPrice(value, cloumn) {
      let price = parseFloat(value[cloumn.property]);
      let open = parseFloat(value["open"]);
      //   console.log("-price:", open, price);
      let priceClassName;
      if (price > open) {
        priceClassName = "text-success";
      } else {
        priceClassName = "text-danger";
      }

      return this.$createElement("price-label", {
        props: { priceClassName, price: price.toFixed(8) },
      });
    },
    formatterDateTime(value, cloumn) {
      let date = value[cloumn.property];
      var m = moment(date);
      return m.format("YYYY-MM-DD HH:mm:ss");
    },
    paginationChanged(page) {
      this.pagination.currentPage = page;
    },

    async handleLike(index, row, status) {
      // console.log(index, row, status);
      const market_id = row.market_id;
      console.log("market_id:", market_id, status);

      const res = await linearSwapApi.fav(market_id, status);
      if (res && res.code == 200) {
        row.is_fav = status;
      }
    },

    async onSubmit() {
      // console.log("onSubmit");
      // console.log(this.formModal);

      if (this.formModal.platform <= 0) {
        swal.fire({
          title: `请选择市场`,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-success btn-fill",
          },
          confirmButtonText: "确定",
        });
        return;
      }

      const { code } = await linearSwapApi.setMarket(this.formModal);
      if (code == 200) {
        this.modals.form = false;
        this.$notify({
          message: "交易对保存成功！",
          timeout: 5000,
          icon: "ni ni-bell-55",
          type: "success",
        });
        this.getEntries();
        return;
      }
    },

    async handleEdit(index, row) {
      const id = row && row.market_id ? row.market_id : 0;
      let data;
      if (id) {
        const res = await linearSwapApi.getMarket(id);
        const { code } = res;
        if (code != 200) {
          return;
        }
        data = res.data;
        console.log("-----data:", data);
        this.form_title = " 编辑交易对 - " + id + " - " + data.symbol;
      } else {
        data = null;
        this.form_title = "添加交易对";
      }

      this.formModal.id = id;

      if (data) {
        const keyLevelRise =
          Math.round(data.keyLevelRise * 100000000) / 100000000;
        const keyLevelFall =
          Math.round(data.keyLevelFall * 100000000) / 100000000;
        this.formModal.id = data.id;
        this.formModal.symbol = data.symbol;
        this.formModal.platform = data.platform;
        this.formModal.keyLevelRise = keyLevelRise;
        this.formModal.keyLevelFall = keyLevelFall;
      } else {
        //设置默认值
        this.formModal.id = 0;
        this.formModal.symbol = "";
        this.formModal.platform = "1";
        this.formModal.keyLevelRise = "";
        this.formModal.keyLevelFall = "";
      }

      this.modals.form = true;
    },
    // handleDelete(index, row) {
    //   swal({
    //     title: "Are you sure?",
    //     text: `You won't be able to revert this!`,
    //     type: "warning",
    //     showCancelButton: true,
    //     confirmButtonClass: "btn btn-success btn-fill",
    //     cancelButtonClass: "btn btn-danger btn-fill",
    //     confirmButtonText: "Yes, delete it!",
    //     buttonsStyling: false,
    //   }).then((result) => {
    //     if (result.value) {
    //       this.deleteRow(row);
    //       swal({
    //         title: "Deleted!",
    //         text: `You deleted ${row.name}`,
    //         type: "success",
    //         confirmButtonClass: "btn btn-success btn-fill",
    //         buttonsStyling: false,
    //       });
    //     }
    //   });
    // },
    // deleteRow(row) {
    //   let indexToDelete = this.tableData.findIndex(
    //     (tableRow) => tableRow.id === row.id
    //   );
    //   if (indexToDelete >= 0) {
    //     this.tableData.splice(indexToDelete, 1);
    //   }
    // },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },

    /**
     * 获取所有合约
     */
    async getEntries() {
      var formData = {};
      if (this.shock_times != "") {
        formData.shock_times = this.shock_times;
      }

      if (this.shock_length != "") {
        formData.shock_length = this.shock_length;
      }

      const res = await linearSwapApi.all(formData);
      if (res && res.code == 200) {
        const { data } = res;
        this.tableData = data;
      }
    },
    async selectKLine(time) {
      this.selectedKLine = time;
      this.getEntries();
    },
  },
  async mounted() {
    await this.getEntries();
    // this.timer = setInterval(this.getEntries, 3000);

    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["contract_code"],
      threshold: 0.3,
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    shock_times: function (val) {
      this.pagination.currentPage = 1;
      this.getEntries();
    },
    shock_length: function (val) {
      this.pagination.currentPage = 1;
      this.getEntries();
    },
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
